import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const CTASection: React.FC = () => {
  const { t } = useTranslation();

  const trustItems = t('cta.trustItems', { returnObjects: true }) as { icon: string; label: string }[];

  return (
    <section id="cta" className="hp-cta" aria-labelledby="cta-title">
      <div className="hp-cta-inner">
        <h2 id="cta-title">{t('cta.title')}</h2>
        <p>{t('cta.subtitle')}</p>

        <Link
          to="/register"
          className="hp-btn-hero-primary"
          style={{ fontSize: 18, padding: '18px 44px' }}
        >
          {t('cta.button')}
        </Link>

        <div className="hp-cta-trust-bar">
          {trustItems.map((item) => (
            <div key={item.label} className="hp-cta-trust-item">
              <span className="hp-cta-trust-icon" aria-hidden="true">{item.icon}</span>
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
